import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { fieldRegistry } from "./fieldRegistry";
export function renderInteractionRequestField({ key, field, rawValue, disabled, error, onFieldChange, }) {
    switch (field.type) {
        case "file": {
            const FieldComponent = fieldRegistry.file.renderer;
            return (_jsx(FieldComponent, { field: field, value: rawValue, onChange: (v) => onFieldChange(field.name, v), disabled: disabled, error: error }, key));
        }
        case "shortText": {
            const FieldComponent = fieldRegistry.shortText.renderer;
            const value = rawValue === undefined || rawValue === null ? "" : String(rawValue);
            return (_jsx(FieldComponent, { field: field, value: value, onChange: (v) => onFieldChange(field.name, v), disabled: disabled, error: error }, key));
        }
        case "longText": {
            const FieldComponent = fieldRegistry.longText.renderer;
            const value = rawValue === undefined || rawValue === null ? "" : String(rawValue);
            return (_jsx(FieldComponent, { field: field, value: value, onChange: (v) => onFieldChange(field.name, v), disabled: disabled, error: error }, key));
        }
        case "number": {
            const FieldComponent = fieldRegistry.number.renderer;
            const value = typeof rawValue === "number" || typeof rawValue === "string"
                ? rawValue
                : rawValue === undefined || rawValue === null
                    ? ""
                    : String(rawValue);
            return (_jsx(FieldComponent, { field: field, value: value, onChange: (v) => onFieldChange(field.name, v), disabled: disabled, error: error }, key));
        }
        case "dropdown": {
            const FieldComponent = fieldRegistry.dropdown.renderer;
            const value = rawValue === undefined || rawValue === null ? "" : String(rawValue);
            return (_jsx(FieldComponent, { field: field, value: value, onChange: (v) => onFieldChange(field.name, v), disabled: disabled, error: error }, key));
        }
        case "radio": {
            const FieldComponent = fieldRegistry.radio.renderer;
            const value = rawValue === undefined || rawValue === null ? "" : String(rawValue);
            return (_jsx(FieldComponent, { field: field, value: value, onChange: (v) => onFieldChange(field.name, v), disabled: disabled, error: error }, key));
        }
        case "checkbox": {
            const FieldComponent = fieldRegistry.checkbox.renderer;
            const value = Array.isArray(rawValue) ? rawValue.map(String) : [];
            return (_jsx(FieldComponent, { field: field, value: value, onChange: (v) => onFieldChange(field.name, v), disabled: disabled, error: error }, key));
        }
        case "date": {
            const FieldComponent = fieldRegistry.date.renderer;
            const value = rawValue === undefined || rawValue === null ? "" : String(rawValue);
            return (_jsx(FieldComponent, { field: field, value: value, onChange: (v) => onFieldChange(field.name, v), disabled: disabled, error: error }, key));
        }
        default: {
            return (_jsxs("div", { className: "text-sm text-muted-foreground", children: ["Unsupported field type: ", field.type] }, key));
        }
    }
}
//# sourceMappingURL=renderField.js.map